// Rotas do painel para o GESTOR (Onda 5b): so Agenda, Dashboard, Funil (so visualizacao), Recursos e Configuracoes
// (so os dados pessoais). Para o DIRETOR este componente nao faz nada: devolve a tela de sempre.
import React, { lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ehEquipe, tokenVencido } from '../lib/papel';

const FunilVisualizacao = lazy(() => import('../pages/admin/FunilVisualizacao').then((m) => ({ default: m.FunilVisualizacao })));
const ConfiguracoesGestor = lazy(() => import('../pages/admin/ConfiguracoesGestor').then((m) => ({ default: m.ConfiguracoesGestor })));
const LIBERADAS = ['/admin/agenda', '/admin/dashboard', '/admin/recursos'];

export function RotaEquipe({ children }) {
  const loc = useLocation();
  if (!ehEquipe()) return children;
  if (tokenVencido()) {
    try { localStorage.removeItem('token'); } catch (e) { /* ok */ }
    return <Navigate to="/admin/login" replace />;
  }
  const p = loc.pathname.replace(/\/+$/, '');
  if (p === '/admin/funil') return <FunilVisualizacao />;
  if (p === '/admin/configuracoes') return <ConfiguracoesGestor />;
  if (LIBERADAS.includes(p)) return children;
  return <Navigate to="/admin/agenda" replace />;
}

export default RotaEquipe;
